export default __webpack_public_path__ + "static/media/container_tracking-white.beabfeb2.svg";